import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth is carried via an httpOnly cookie set by the backend; send it on every request.
const api = axios.create({ baseURL: API, withCredentials: true });

// Normalize FastAPI error detail (422 returns an array of objects) into a plain string
// so components can safely render `err.response.data.detail` in toasts.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const d = error?.response?.data?.detail;
    if (Array.isArray(d)) {
      error.response.data.detail = d.map((x) => x?.msg || (typeof x === "string" ? x : JSON.stringify(x))).join("; ");
    } else if (d && typeof d === "object") {
      error.response.data.detail = d.msg || JSON.stringify(d);
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };
